import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import eruda from 'eruda';

// Initialize Eruda for Mobile Debugging (Replacing vConsole)
eruda.init();
console.log("Eruda Active: Mobile DevTools ready.");

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Uncaught error:", error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '20px',
          backgroundColor: '#300',
          color: '#fff',
          height: '100vh',
          overflow: 'auto',
          textAlign: 'left',
          fontFamily: 'monospace'
        }}>
          <h1 style={{ color: 'red', borderBottom: '1px solid red' }}>CRASH DETECTED</h1>
          <h3 style={{ color: '#ffaaaa' }}>Error:</h3>
          <pre style={{ whiteSpace: 'pre-wrap', backgroundColor: '#500', padding: '10px' }}>
            {this.state.error && this.state.error.toString()}
          </pre>
          <h3 style={{ color: '#ffaaaa' }}>Component Stack:</h3>
          <pre style={{ whiteSpace: 'pre-wrap', backgroundColor: '#500', padding: '10px', fontSize: '0.8rem' }}>
            {this.state.errorInfo && this.state.errorInfo.componentStack}
          </pre>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              fontSize: '1.2rem',
              backgroundColor: '#fff',
              color: '#000',
              border: 'none',
              borderRadius: '4px'
            }}
          >
            RELOAD APP
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)
